import api from './config';

// 获取菜单配置列表
export const getMenuConfigs = async (boardType = '') => {
  const params = boardType ? { board_type: boardType } : {};
  return api.get('/menus', { params });
};

// 获取单个菜单配置
export const getMenuConfig = async (menuId) => {
  return api.get(`/menus/${menuId}`);
};

// 创建菜单配置
export const createMenuConfig = async (data) => {
  return api.post('/menus', data);
};

// 更新菜单配置
export const updateMenuConfig = async (menuId, data) => {
  return api.put(`/menus/${menuId}`, data);
};

// 删除菜单配置
export const deleteMenuConfig = async (menuId) => {
  return api.delete(`/menus/${menuId}`);
};

// 微信接口：获取菜单配置（不需要认证）
export const getWxMenuConfigs = async (boardType = '1') => {
  const baseUrl = process.env.VUE_APP_API_BASE_URL || '';
  const apiBase = baseUrl.endsWith('/api') ? baseUrl : `${baseUrl}/api`;
  const response = await fetch(`${apiBase}/wx/menus?board_type=${boardType}`);
  return response.json();
};

